var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelloGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 462 341",
    style: {
      enableBackground: "new 0 0 462 341"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8F9FD;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#BCC1C6;}\n\t.st3{fill:#0095F7;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#007BCC;}\n\t.st6{fill:#7E330F;}\n\t.st7{fill:#363636;}\n\t.st8{fill:#F9CF93;}\n\t.st9{fill:#232323;}\n\t.st10{opacity:0.31;}\n\t.st11{fill:#994016;}\n\t.st12{fill:none;stroke:#F9CF93;stroke-width:3;stroke-linecap:round;}\n\t.st13{fill:#39393B;}\n\t.st14{fill:#CDAB7B;}\n\t.st15{fill:#9ECAFF;}\n\t.st16{fill:#E4E6EB;}\n\t.st17{fill:#D9D9D9;}\n\t.st18{fill:#C8C8C8;fill-opacity:0.47;}\n\t.st19{fill:url(#SVGID_00000088836538581491604300000004817723202284467356_);}\n\t.st20{fill:#FFFEFE;}\n\t.st21{fill:url(#SVGID_00000086651954465922472440000007653331124703327159_);}\n\t.st22{fill:#77959E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.4,299.7c101.9-17.7,107-67.9,81.2-112.7c-32.2-55.8-2-94.4-43.3-102.9c-42.9-8.9-43.4,99.5-142.1,98.3 C103.4,180.7,225,322.1,353.4,299.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.6,35.8C5.9,51.4,1.4,95.5,24.1,135c28.3,49.1,1.7,83.1,38.1,90.6c37.7,7.8,38.2-87.5,125-86.5 C315.6,140.6,208.6,16.1,95.6,35.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.8156,
    y1: 340.2566,
    x2: 139.7366,
    y2: 79.2357,
    gradientTransform: "matrix(1 0 0 -1 0 342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8F9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#ECEFF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#E1E6ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#E2E5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3E5EA"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.9,49.5c0-8.1,6.5-14.6,14.6-14.6h289.5c8.1,0,14.6,6.5,14.6,14.6v200c0,8.1-6.5,14.6-14.6,14.6H93.5 c-8.1,0-14.6-6.5-14.6-14.6V49.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.8,183.2c0-4.5,3.6-8.1,8.1-8.1h185.6c4.5,0,8.1,3.6,8.1,8.1v117.6c0,4.5-3.6,8.1-8.1,8.1H121.9 c-4.5,0-8.1-3.6-8.1-8.1V183.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M222.5,97.3l-98.4,79.5v14.8h103.8h103.8v-14.8l-98.4-79.5C230.2,94.8,225.7,94.8,222.5,97.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.6,273.8H147.3c-4.7,0-8.6-3.8-8.6-8.6V103.2c0-4.7,3.8-8.6,8.6-8.6h165.3c4.7,0,8.6,3.8,8.6,8.6v161.9 C321.1,269.9,317.3,273.8,312.6,273.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.3,140.1c0,23.6-19.1,42.6-42.8,42.6c-23.6,0-42.8-19.1-42.8-42.6c0-23.6,19.1-42.7,42.8-42.7 C251.2,97.4,270.3,116.5,270.3,140.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.3,211.1c-0.7,0-1.3-0.2-1.6-0.6c-0.4-0.4-0.5-0.9-0.5-1.5c0-0.7,0.2-1.3,0.6-1.8c0.4-0.4,1-0.7,1.7-0.7 c0.7,0,1.2,0.2,1.6,0.5c0.4,0.3,0.5,0.9,0.5,1.5c0,0.8-0.2,1.3-0.6,1.8C259.6,210.9,259.1,211.1,258.3,211.1z M259.2,205.3 c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.2-0.3-0.4-0.3-0.7l0-0.2c0.3-1.8,0.6-3.9,1.1-6.2c0.5-2.3,0.9-4.3,1.3-6c0.3-1,1-1.6,2.1-1.6 c1,0,1.6,0.3,1.6,1c0,0.2,0,0.3-0.1,0.5c-0.4,1.7-1,3.8-1.7,6.2c-0.7,2.4-1.4,4.6-2,6.4C260.3,205,259.9,205.3,259.2,205.3z  M249.3,208.4c0.5,0,1-0.3,1.4-0.9c0.4-0.6,0.6-1.5,0.6-2.6c0-0.9-0.2-1.6-0.5-2c-0.3-0.5-0.7-0.7-1.2-0.7c-0.6,0-1.1,0.3-1.5,0.9 c-0.4,0.6-0.6,1.5-0.6,2.6c0,0.9,0.2,1.6,0.5,2C248.4,208.2,248.8,208.4,249.3,208.4z M249,211.1c-1,0-1.8-0.2-2.5-0.7 c-0.7-0.5-1.2-1.1-1.5-1.9c-0.3-0.8-0.5-1.6-0.5-2.5c0-1.2,0.2-2.3,0.7-3.3c0.5-1,1.1-1.7,1.9-2.3c0.8-0.5,1.7-0.8,2.7-0.8 c1,0,1.8,0.2,2.5,0.7c0.7,0.5,1.2,1.1,1.5,1.9c0.3,0.8,0.5,1.6,0.5,2.5c0,1.2-0.2,2.3-0.7,3.3c-0.5,1-1.1,1.7-1.9,2.3 C250.9,210.8,250,211.1,249,211.1z M242.7,190.5c-0.4,0-0.8,0.7-1.3,2c-0.5,1.3-0.9,3-1.2,5c-0.4,2-0.6,3.9-0.6,5.7 c1.2-1.9,2.1-3.8,2.7-5.7c0.7-1.9,1-3.6,1-5.2C243.3,191.1,243.1,190.5,242.7,190.5z M243.6,210.2c-0.8,0.6-1.7,0.8-2.8,0.8 c-1.4,0-2.5-0.6-3.2-1.9c-0.7-1.3-1-3-1-5c0-2,0.3-4.2,0.8-6.8c0.5-2.5,1.3-4.7,2.3-6.5c1-1.8,2.2-2.7,3.6-2.7 c0.8,0,1.4,0.4,1.8,1.1c0.4,0.7,0.7,1.8,0.7,3.1c0,1.9-0.5,4.2-1.6,6.7c-1.1,2.5-2.5,5.1-4.3,7.6c0.1,0.7,0.3,1.1,0.6,1.4 c0.3,0.3,0.6,0.4,1,0.4c0.7,0,1.2-0.2,1.7-0.6c0.5-0.4,0.7-0.3,1.5-1.2C244.8,206.4,244.4,209.7,243.6,210.2z M234.2,190.5 c-0.4,0-0.8,0.7-1.3,2c-0.5,1.3-0.9,3-1.2,5c-0.4,2-0.6,3.9-0.6,5.7c1.2-1.9,2.1-3.8,2.7-5.7c0.7-1.9,1-3.6,1-5.2 C234.8,191.1,234.6,190.5,234.2,190.5z M236.6,209c-0.7,0.9-0.7,0.7-1.5,1.3c-0.8,0.6-1.7,0.8-2.8,0.8c-1.4,0-2.5-0.6-3.2-1.9 c-0.7-1.3-1-3-1-5c0-2,0.3-4.2,0.8-6.8c0.5-2.5,1.3-4.7,2.3-6.5c1-1.8,2.2-2.7,3.6-2.7c0.8,0,1.4,0.4,1.8,1.1 c0.4,0.7,0.7,1.8,0.7,3.1c0,1.9-0.5,4.2-1.6,6.7c-1.1,2.5-2.5,5.1-4.4,7.6c0.1,0.7,0.3,1.1,0.6,1.4c0.3,0.3,0.6,0.4,1,0.4 c0.7,0,1.2-0.2,1.7-0.6c0.5-0.4,1.1-1,1.9-2C236.7,205.6,236.9,208.6,236.6,209z M222.5,202c-0.6,0-1.1,0.3-1.5,1 c-0.4,0.7-0.6,1.5-0.6,2.5v0c1-0.2,1.7-0.6,2.3-1c0.6-0.5,0.8-1,0.8-1.6c0-0.3-0.1-0.6-0.3-0.7C223,202.1,222.8,202,222.5,202z  M228.4,208.4c-0.6,0.7-1,1.1-2.1,1.8c-1.1,0.6-2.3,0.9-3.5,0.9c-1.7,0-3-0.5-4-1.4c-0.9-0.9-1.4-2.2-1.4-3.8c0-1.1,0.2-2.2,0.7-3.1 c0.5-1,1.1-1.7,2-2.3c0.8-0.6,1.8-0.9,2.8-0.9c0.9,0,1.7,0.3,2.3,0.8c0.6,0.6,0.9,1.3,0.9,2.3c0,1.1-0.4,2.1-1.2,2.9 c-0.8,0.8-2.2,1.4-4.1,1.9c0.4,0.8,1.2,1.1,2.3,1.1c0.7,0,1.6-0.3,2.5-0.8c0.9-0.5,1.7-1.2,2.4-2c0.1-0.1,0.1,0.6,0.3,1.3 C228.3,207.8,228.6,208.2,228.4,208.4z M212.1,191.7c-0.4,0-0.7,0.3-1.1,1c-0.4,0.6-0.8,1.5-1.1,2.7c-0.4,1.1-0.6,2.3-0.9,3.7 c1.3-0.5,2.3-1.3,2.9-2.3c0.6-1,0.9-2.3,0.9-3.8c0-0.4-0.1-0.7-0.2-0.9C212.4,191.8,212.3,191.7,212.1,191.7z M215.4,205.5 c0.2,0,0.4,0.1,0.5,0.3c0.1,0.2,0.2,0.5,0.2,0.8c0,0.6-0.2,1.1-0.5,1.5c-1.6,2-3.3,2.9-5.1,2.9c-1.6,0-2.8-0.6-3.8-1.8 s-1.4-3-1.4-5.2c0-0.6,0-1.1,0.1-1.7c-1.1,0.2-2.2,0.3-3.5,0.4c-0.9,0.1-1.4,0.1-1.7,0.1c-0.3,1.7-0.8,3.7-1.4,6.1 c-0.3,1.4-1,2.1-1.9,2.1c-1,0-1.6-0.5-1.6-1.4c0-0.2,0-0.5,0.1-0.9c0.6-2.2,1-4.1,1.3-5.6l-1.2,0c-0.5,0-0.9-0.1-1.2-0.3 c-0.2-0.2-0.4-0.5-0.4-0.9c0-0.5,0.2-0.9,0.5-1.2c0.3-0.3,0.8-0.4,1.5-0.4l1.3-0.1c0.4-2.3,0.6-4,0.6-5.2c0-0.8-0.1-1.3-0.3-1.6 c-0.2-0.3-0.5-0.4-0.9-0.4c-1.1,0-2.4,0.9-3.8,2.8c-0.2,0.3-0.4,0.4-0.7,0.4c-0.2,0-0.4-0.1-0.6-0.3c-0.2-0.2-0.2-0.5-0.2-0.8 c0-0.5,0.2-1,0.6-1.6c0.7-1,1.6-1.8,2.7-2.5c1.1-0.6,2.2-1,3.3-1c1.1,0,1.9,0.4,2.4,1.1c0.6,0.7,0.9,1.8,0.9,3.4 c0,1.3-0.2,3.2-0.6,5.5l2.4-0.1c1-0.1,1.9-0.1,2.6-0.2c0.3-1.8,0.7-3.5,1.3-5c0.6-1.6,1.3-2.8,2.2-3.8c0.9-1,1.9-1.5,3-1.5 c0.8,0,1.5,0.3,1.9,1c0.5,0.6,0.7,1.5,0.7,2.5c0,4-2,6.8-6.2,8.4c-0.1,0.6-0.1,1.3-0.1,2c0,1.7,0.2,2.9,0.6,3.6 c0.4,0.7,1,1.1,1.8,1.1c0.7,0,1.3-0.2,1.8-0.5c0.6-0.4,1.2-1,1.9-1.8C214.9,205.6,215.1,205.5,215.4,205.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.1,156.6c4.2,0,7.4,0.3,7.4-2.5c0-2.8-2.9-4.2-7.1-4.2c-4.2,0-7.8,1.2-7.8,4 C224.6,156.7,227.9,156.6,232.1,156.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M224,133.1c4.3,0,7.8-3.5,7.8-7.7c0-4.3-3.5-7.7-7.8-7.7c-4.3,0-7.8,3.5-7.8,7.7 C216.2,129.6,219.7,133.1,224,133.1z M240,132.3c4.3,0,7.8-3.5,7.8-7.7c0-4.3-3.5-7.7-7.8-7.7c-4.3,0-7.8,3.5-7.8,7.7 C232.2,128.8,235.7,132.3,240,132.3z M239.3,126.3c4.3,0,7.8-3.5,7.8-7.7c0-4.3-3.5-7.7-7.8-7.7c-4.3,0-7.8,3.5-7.8,7.7 C231.5,122.9,235,126.3,239.3,126.3z M224.3,127c4.3,0,7.8-3.5,7.8-7.7c0-4.3-3.5-7.7-7.8-7.7c-4.3,0-7.8,3.5-7.8,7.7 C216.5,123.5,220,127,224.3,127z M231.8,124c4.3,0,7.8-3.5,7.8-7.7c0-4.3-3.5-7.7-7.8-7.7c-4.3,0-7.8,3.5-7.8,7.7 C224,120.5,227.5,124,231.8,124z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M228.8,157.6l-1.4-0.7c-1-0.5-1.7-1.3-2-2.3c-0.3-1-0.2-2.1,0.3-3c1.4-2.6,1.4-5.3,1-7.5 c-0.2-1.1,0.1-2.3,0.9-3.2c0.8-0.9,1.9-1.4,3-1.4c2.2,0,4,1.8,4,3.9v10.7c0,1.4-0.7,2.6-1.9,3.3C231.5,158.1,230,158.2,228.8,157.6z  M235.3,157.8c-1.2,0.6-2.7,0.5-3.8-0.2c-1.2-0.7-1.9-2-1.9-3.3v-10.7c0-1,0.4-2,1.2-2.8c0.7-0.7,1.7-1.2,2.8-1.2 c1.2,0,2.3,0.5,3,1.4c0.8,0.9,1.1,2.1,0.9,3.2c-0.4,2.2-0.4,4.9,1,7.5c0.5,0.9,0.6,2,0.3,3c-0.3,1-1.1,1.8-2,2.3L235.3,157.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M220.8,139.7c1.9,0,3.5-1.6,3.5-3.5c0-1.9-1.6-3.5-3.5-3.5c-1.9,0-3.5,1.6-3.5,3.5 C217.3,138.1,218.8,139.7,220.8,139.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M242.8,139.6c1.9,0,3.5-1.6,3.5-3.5c0-1.9-1.6-3.5-3.5-3.5c-1.9,0-3.5,1.6-3.5,3.5 C239.3,138,240.9,139.6,242.8,139.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M245.8,131.7c0,5.3-2.4,12.2-6.8,14.4c-1.9,1-3.2,4-7.1,3.9c-4-0.1-5-3-7-4.1c-4.3-2.3-6.8-9.1-6.8-14.3 c0.1-7.5,6.2-13.5,13.8-13.5C239.5,118.2,245.7,124.2,245.8,131.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M231.9,115.7c-17.9-0.6-13.7,17.4-13.7,17.4c0.8-2.1,1.5-4.3,2.3-6.4c0.4-1,0.9-1.9,1.5-2.7 c0.5-0.7,1.1-1.5,1.9-1.8c0.9-0.3,1.9,0.1,2.8,0.2c0.4,0,4.6,0.2,5.2,0c0.6,0.2,4.8,0,5.2,0c0.9-0.1,1.9-0.5,2.8-0.2 c0.9,0.3,1.4,1.2,1.9,1.8c0.6,0.8,1.1,1.7,1.5,2.7c0.9,2.1,1.6,4.3,2.3,6.4C245.6,133.1,249.8,115,231.9,115.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M225.6,153.3c1.2,2.2,7.4,2.8,6.4,2.8v30.6l-17.6-1.2c-0.8-3.8-1.3-21.9,1.8-24.3c0.6-0.5,1.8-4.1,3-6.1 c0.6-1,1.1-0.8,1.7-1.2c3.5-2.3,4.1-1.8,4.1-1.8L225.6,153.3z M238.5,153.3l0.5-1c0,0,3.4,1.8,8.8,5.9c3.2,2.4,4.7,19.5,3.9,23.3 l-19.8,1v-26.3C231.9,156.1,237.3,155.5,238.5,153.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M221.3,171.6c0,0,0.2,11.2-2,11.2c-2.2,0-5.1-1.2-5.1-1.2L221.3,171.6z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.1,165.3c0,0-4.3-7.9-4.5-8.5s-0.8-4.6-2.9-7.3c-1.2-1.5-1.7-1.1-1.4,0.4c0.1,0.7,0.8,2.8,0.8,2.8 s-2.4-5.1-3.7-5.6c-0.2-0.1-0.9-0.6-1.4-0.5c-0.5,0.2-1.2,0-1.6,0.5c-0.5,0.5-0.6,1.2-0.7,1.8c0,0.4,0.1,1,0.4,1.7 c0.4,1,1.2,3.6,3.2,6.7c0.8,1.2,3.1,3.4,3.1,3.4l4,8.6l5-3.4L200.1,165.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.2,165.6l-0.5-1.7c0,0-1.8,1.6-2.6,2c-0.8,0.4-3.1,1-3.1,1l1.1,1.5L200.2,165.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.8,169.4c-0.5-0.9-2.6-4.7-2.6-4.7l-7.6,3.6c0,0,6.2,16.2,9.1,19.3c1.7,1.9,3.9,2.5,5.4,2 C214.2,187.7,204.5,170.4,203.8,169.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M219.3,155.2c0,0-5.2,2.7-8.6,13.7c-1.2,3.9-0.2,2.4-0.4,1.2c-0.2-1-3.5,20.6-1.9,20.6c6.3,0,11.9-17,11.9-17 L219.3,155.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M232.5,144c2.2,0,4.1-3,4.1-3h-8.1C228.4,141,230.2,144,232.5,144z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M225.4,131.7c0,0,2-1.6,4.1,0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M234.5,131.7c0,0,2-1.6,4.1,0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M243,169.4l-0.6,12.2l3.1-2L243,169.4z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M230.1,128.3c1-0.3,0.6-1.2-0.5-1.2c-1.8,0-4.7,0.3-4.8,1.2C224.8,129.7,228,128.9,230.1,128.3 C230.1,128.4,230.1,128.3,230.1,128.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M235.5,128.7c-0.9-0.3-0.4-1.2,0.7-1.2c1.8,0.1,4.6,0.3,4.5,1.2C240.6,130.1,237.5,129.3,235.5,128.7 C235.6,128.7,235.5,128.7,235.5,128.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M227.6,133.9c-0.8,0-1.5-0.3-1.5-0.8c0-0.5,0.6-0.8,1.5-0.9c0.8,0,1.5,0.3,1.5,0.8 C229.1,133.5,228.4,133.9,227.6,133.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M237.6,134.2c-0.8,0.1-1.5-0.2-1.5-0.7c0-0.5,0.6-0.9,1.4-0.9c0.8-0.1,1.5,0.2,1.5,0.7 C239.1,133.7,238.4,134.1,237.6,134.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M233.6,133c0.1,3.9,2.6,5.6,2.6,5.6c-0.5,0.4-3.3,0.4-3.3,0.4L233.6,133z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331.7,177v116.9c0,4.7-3.8,8.5-8.6,8.5H132.7c-4.7,0-8.6-3.8-8.6-8.5V177l104.9,82.7L331.7,177z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.6,298.2l-96.1-77.5c-3.1-2.5-7.6-2.5-10.7,0l-97.6,78.6c1.6,1.9,3.9,3.1,6.6,3.1h190.5 C326.3,302.4,329.1,300.7,330.6,298.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308,30.3l10.5-8.9l7.1,8.3l-10.5,8.9L308,30.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.2,33.7l10.5-8.9l7.1,8.3L185.3,42L178.2,33.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.9,331.4l10.5-8.9l7.1,8.3l-10.5,8.9L170.9,331.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M38.8,105.7l10.5-8.9l7.1,8.3L45.9,114L38.8,105.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M259.1,272.1l3.5-9.5l7.6,2.8l-3.5,9.5L259.1,272.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.4,212.9l10.1,1.1l-0.9,8L57.5,221L58.4,212.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M211.6,102.5l3.6-9.8l7.8,2.9l-3.6,9.8L211.6,102.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M414.2,160l10.1,1.1l-0.9,8l-10.1-1.1L414.2,160z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.7,187.3l-7-8.1l6.5-5.6l7,8.1L165.7,187.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M362.1,111.1l15.8-8.4l7,13l-15.8,8.4L362.1,111.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M305.5,214.6c0-1.3,1-2.3,2.3-2.3h65.9c1.3,0,2.3,1,2.3,2.3v95.4c0,1.3-1,2.3-2.3,2.3h-65.9 c-1.3,0-2.3-1-2.3-2.3V214.6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M326.8,287.4h23.5v3.2h-23.5V287.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M320.4,278.7h39.9v3.8h-39.9V278.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178904453568374083520000008177732463341308039_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.5733,
    y1: 111.9935,
    x2: 349.3834,
    y2: 65.6335,
    gradientTransform: "matrix(1 0 0 -1 0 342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5D3E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    style: {
      stopColor: "#E5EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ACBDDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178904453568374083520000008177732463341308039_)"
    },
    d: "M340.3,269.5c-11,0-19.9-8.9-19.9-19.8 c0-10.9,8.9-19.8,19.9-19.8c11,0,19.9,8.9,19.9,19.8C360.2,260.6,351.3,269.5,340.3,269.5z M340.3,258.9c5.1,0,9.2-4.1,9.2-9.2 c0-5.1-4.1-9.2-9.2-9.2c-5.1,0-9.2,4.1-9.2,9.2C331.1,254.8,335.2,258.9,340.3,258.9z"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M340.3,240.7l0.8,44.6l13.5-19.5l28.7-41.5l-18.7-6.7l-24.7,1.2L340.3,240.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M368.6,160.4c5-10.6,17.7-15.1,28.3-10.1c10.6,5,15.1,17.7,10.1,28.3c-4.6,9.6-15.4,14.2-25.3,11.2l-5.9,4 l-0.6-7.2C367.2,180.8,364.1,169.8,368.6,160.4z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M386.8,179.2l-8.3-6l2.9-3.9l4.5,3.3l8.9-11.4l3.8,3L386.8,179.2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.4,245.6v57.9c0,2.7,2,4.8,4.6,4.8h63.9c2.5,0,4.6-2.2,4.6-4.8v-57.9H104.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030488600966418268190000011447436199455155863_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.8515,
    y1: 112.6841,
    x2: 142.2595,
    y2: 86.8871,
    gradientTransform: "matrix(1 0 0 -1 0 342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5D3E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    style: {
      stopColor: "#E5EBF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ACBDDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030488600966418268190000011447436199455155863_)"
    },
    d: "M104.4,230.3h73v19.9h-73V230.3z"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.5,238h4.6v4.6h-4.6V238z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.6,238h4.6v4.6h-4.6V238z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166,242.6H134c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3H166c1.3,0,2.3,1,2.3,2.3S167.2,242.6,166,242.6z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115,279.3h13.7v16.8H115V279.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M133.3,295.5H147v0.7h-13.7V295.5z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M151.5,286.4h13.7v9.7h-13.7V286.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M167.5,299.2h-54.8c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3h54.8c1.3,0,2.3,1,2.3,2.3S168.8,299.2,167.5,299.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelloGraphic);
export default __webpack_public_path__ + "static/media/HelloGraphic.4f7e33f419e69ca5a6729fa4b5e63daa.svg";
export { ForwardRef as ReactComponent };